import type { ComponentRef, ViewContainerRef } from '@angular/core'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators'

import { TransitionService } from './transition.service'
import { SiteNavContainerComponent } from '../components/member/site-nav-container/site-nav-container.component'

@Injectable({
  providedIn: 'root',
})
export class SiteNavService {
  private viewContainerRef!: ViewContainerRef
  private siteNavRef!: ComponentRef<SiteNavContainerComponent> | null

  private readonly _visible = new BehaviorSubject(false)
  visible$ = this._visible.pipe(distinctUntilChanged())

  get visible(): boolean {
    return this._visible.getValue()
  }

  set visible(val: boolean) {
    this._visible.next(val)
  }

  constructor() {
    const transitionService = inject(TransitionService)

    transitionService.onStart({}, () => {
      this.close()
    })
  }

  toggle(): void {
    this.visible = !this.visible
  }

  close(): void {
    this.visible = false
  }

  init(ref: ViewContainerRef): void {
    this.viewContainerRef = ref

    this.visible$.subscribe(val => {
      if (val) {
        this.show()
      } else {
        this.hide()
      }
    })
  }

  private create(): void {
    if (!this.siteNavRef) {
      this.siteNavRef = this.viewContainerRef.createComponent(SiteNavContainerComponent)
      this.siteNavRef.instance.onClose(() => this.close())
    }
  }

  private destroy(): void {
    if (this.siteNavRef) {
      this.siteNavRef.destroy()
      this.siteNavRef = null
    }
  }

  private show(): void {
    this.create()
  }

  private hide(): void {
    this.destroy()
  }
}
